<ng-container *ngIf="vm$ | async as vm">
    <div *ngIf="vm.info; else notFound">
        <div [ngSwitch]="vm.layoutType">
            <!--Layout 1-->
            <ss-campaign-layout-one-component *ngSwitchCase="1" 
                                              [campaignInformation]="vm.info" 
                                              [schoolIconLogo]="vm.schoolIconLogo" 
                                              [showSchoolIconLogo]="vm.showSchoolIconLogo">
            </ss-campaign-layout-one-component>
            <!--Layout 2-->
            <ss-campaign-layout-two-component *ngSwitchCase="2" 
                                              [campaignInformation]="vm.info" 
                                              [schoolIconLogo]="vm.schoolIconLogo" 
                                              [showSchoolIconLogo]="vm.showSchoolIconLogo">
            </ss-campaign-layout-two-component>
            <!--Layout 3-->
            <ss-campaign-layout-three-component *ngSwitchCase="3" 
                                                [campaignInformation]="vm.info" 
                                                [schoolIconLogo]="vm.schoolIconLogo" 
                                                [showSchoolIconLogo]="vm.showSchoolIconLogo">
            </ss-campaign-layout-three-component>
        </div>
    </div>

    <ng-template #notFound>

        <!-- flex container -->
        <div id="flex-container">
            <!-- flex item -->
            <div class="flex-item">
                <div>
                    <h1>404</h1>
                    <p>this page is no longer available but there are more stories here: <a routerLink="/gallery">{{vm.urlBase}}/gallery</a></p>
                </div>
            </div>

        </div>
    </ng-template>
</ng-container>
